import { render, staticRenderFns } from "./PatientWidgetDataVueComponent.vue?vue&type=template&id=85e48d24&"
import script from "./PatientWidgetDataVueComponent.vue?vue&type=script&lang=ts&"
export * from "./PatientWidgetDataVueComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PatientWidgetDataVueComponent.vue?vue&type=style&index=0&id=85e48d24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports